import './AccessInput.scss';
import LetterLogo from '../../assets/dashboard/LetterLogo';
import { colors } from '../../constants/colors';

const AccessInput = ({ value, onFocus, onBlur, onChange, focus, placeholder, withoutLogo }) => (
  <div className="position-relative w-100 access-input-container">
    <input
      type="text"
      value={value}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      className={`form-control rounded-0 access-input ${focus ? 'access-input-focus' : ''}`}
      autoComplete="off"
      data-testid="login-input-email-input"
      id="access-without-account-input"
    />
    <label
      htmlFor="access-without-account-input"
      className={`access-input-label ${focus || value ? 'access-input-label-float' : ''}`}
    >
      {withoutLogo || (
        <LetterLogo fill={focus || value ? colors.lightBlue : colors.lightGrayAlkemy} />
      )}
      {placeholder}
    </label>
  </div>
);

export default AccessInput;
